import { render, staticRenderFns } from "./tallaParaLaEdadNinas0a2A.vue?vue&type=template&id=bd79f4d4&scoped=true&"
import script from "./tallaParaLaEdadNinas0a2A.vue?vue&type=script&lang=js&"
export * from "./tallaParaLaEdadNinas0a2A.vue?vue&type=script&lang=js&"
import style0 from "./tallaParaLaEdadNinas0a2A.vue?vue&type=style&index=0&id=bd79f4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd79f4d4",
  null
  
)

export default component.exports